import IComponent from "components/commons/IComponent";
import "./DetailPanels.scoped.css";

import { dataProcessFunctions } from "./dataProcessFunctions";
import { cacheItemResult } from "store/searchResultSlice";

class eLPMIS extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      finaleLPMISResult: [],
      LPMReportTemplate: [
        {
          alias: "LPM Study Feature No.",
          field: "FEATURENO",
          value: "",
        },
        {
          alias: "Location",
          field: "LOCATION",
          value: "",
        },
        {
          alias: "District Council",
          field: "DISTRICTCOUNCIL",
          value: "",
        },
        {
          alias: "Maintenance Responsibility (at the time of selection)",
          field: "MR",
          value: "",
        },
        {
          alias: "Responsible Party for maintenance of Government portion",
          field: "GOV_PTY",
          value: "",
        },
        {
          alias: "Private Lot No.",
          field: "PRI_PTY",
          value: "",
        },
      ],
      LPMStudyTemplate: [
        {
          alias: "Agreement No.",
          field: "AGREENO",
          value: "",
        },
        {
          alias: "Study Type",
          field: "STUDYTYPE",
          value: "",
        },
        {
          alias: "Consultant",
          field: "CONSULTANT",
          value: "",
        },
        {
          alias: "GEO Managing Section / Engineer",
          field: ["DIVISION_S", "PE"],
          value: "",
        },
        {
          alias: "Study Status",
          field: "STUDYSTATUS",
          value: "",
        },
        {
          alias: "Design Approach",
          field: "APPROACH",
          value: "",
        },
        {
          alias: "Option Assessment Accepted",
          field: "OPTIONASSESSMENT",
          value: "",
        },
        {
          alias: "Study Report No.",
          field: "S23_REPORTNO",
          value: "",
        },
        {
          alias: "Programme / Actual Commencement",
          field: "COMMENCEMENTDATE_S",
          value: "",
        },
        {
          alias: "Programme / Actual Completion",
          field: "COMPLETIONDATE_S",
          value: "",
        },
        {
          alias: "Report Recommendation (for stage 2 study)",
          field: "RECOMMEND",
          value: "",
        },
        {
          alias: "District Check Status",
          field: "DISTRICTCHECK",
          value: "",
        },
        {
          alias: "Checking Certificate No.",
          field: "CHECKCERTNO",
          value: "",
        },
        {
          alias: "GEO Engineer's Remarks",
          field: "REMARKS",
          value: "",
        },
      ],
      LPMWorksTemplate: [
        {
          alias: "Works Contract No.",
          field: "CONTRACTNO",
          value: "",
        },
        {
          alias: "GEO Managing Section / Engineer",
          field: ["DIVISION_W", "GE"],
          value: "",
        },
        {
          alias: "Contractor",
          field: "CONTRACTOR",
          value: "",
        },
        {
          alias: "Progress Status",
          field: "PROGRESSSTATUS",
          value: "",
        },
        {
          alias: "Reason of Study Termination / Works Deletion (if necessary)",
          field: "REASONDELETE",
          value: "",
        },
        {
          alias: "Forecast Commencement Date",
          field: "COMMENCEMENTDATE_W",
          value: "",
        },
        {
          alias: "Forecast Completion Date",
          field: "COMPLETIONDATE_W",
          value: "",
        },
        {
          alias: "Completion Cert. Issued",
          field: "COMPLETIONCERTDATE",
          value: "",
        },
        {
          alias: "Site Handed Over to Maintenance Department on",
          field: "DATEOFHANDOVER",
          value: "",
        },
        {
          alias: "Estimated Cost for Upgrading (HK$M)",
          field: "TOTALCOST",
          value: "",
        },
        {
          alias: "Maintenance Manual No.",
          field: "MMNO",
          value: "",
        },
        {
          alias: "Actual Works",
          field: "WORKS",
          value: "",
        },
        {
          alias: "No. of Tree Felled",
          field: "NOTREEFELL",
          value: "",
        },
        {
          alias: "No. of Tree Planted (incl. transplant)",
          field: "NOTREEPLANT",
          value: "",
        },
        {
          alias: "% Bare of Slope Surfacing",
          field: "SLPBARE",
          value: "",
        },
        {
          alias: "% Vegetated of Slope Surfacing",
          field: "SLPVEGETATE",
          value: "",
        },
        {
          alias: "% Shotcrete of Slope Surfacing",
          field: "SLPSHOTCRETE",
          value: "",
        },
        {
          alias: "Other Hard Surface of Slope Surfacing",
          field: "SLPOTHERHARDSURF",
          value: "",
        },
      ],
    };
  }
  async componentDidMount() {
    console.log("eLPMIS did mount", this.props);
    let finaleLPMISResult;
    if (this.props.text !== "") {
      let url = `${this.$config.ManMadeSlopeInfoList.eLPMISUrl}`;
      let data = {
        Key: this.props.text,
      };
      finaleLPMISResult = this.props.cachedData;
      if (!finaleLPMISResult) {
        let queryTexturalResults = await this.fetchQueryByPOST(url, data);
        finaleLPMISResult = await queryTexturalResults.json();
      }

      console.log("finaleLPMISResult", finaleLPMISResult);
      this.props.onCachePanelData(this.props.title, finaleLPMISResult);
      if (finaleLPMISResult && finaleLPMISResult.length > 0) {
        // Pass?
      } else {
        this.props.isShowTabCallback(false);
        return;
      }
    }
    let dataProcessClassObj = new dataProcessFunctions();
    let tmpLPMReport = finaleLPMISResult.map((i) =>
      dataProcessClassObj.assignCellValuesWithFieldValueConcatInNewline(
        JSON.parse(JSON.stringify(this.state.LPMReportTemplate)),
        i
      )
    );
    let tmpLPMStudy = finaleLPMISResult.map((i) =>
      dataProcessClassObj.assignCellValuesWithFieldValueConcatInNewline(
        JSON.parse(JSON.stringify(this.state.LPMStudyTemplate)),
        i
      )
    );
    let tmpLPMWorks = finaleLPMISResult.map((i) =>
      dataProcessClassObj.assignCellValuesWithFieldValueConcatInNewline(
        JSON.parse(JSON.stringify(this.state.LPMWorksTemplate)),
        i
      )
    );

    let data = {
      LPMReport: tmpLPMReport,
      LPMStudy: tmpLPMStudy,
      LPMWorks: tmpLPMWorks,
    };
    this.setState(data);
    this.props.isShowTabCallback(true);
  }
  render() {
    let { LPMReport, LPMStudy, LPMWorks } = this.state;
    console.log("this.state.LPMReport", LPMReport);
    console.log("this.state.LPMStudy", LPMStudy);
    console.log("this.state.LPMWorks", LPMWorks);
    if (!LPMReport && !LPMStudy && !LPMWorks) return <></>;
    let layout = Array.apply(null, Array(LPMReport.length)).map(
      (dummy, idx) => (
        <div>
          <div className="SubPanelTitle">
            LPM/LPMit Details Report ({LPMStudy[idx][0].value})
          </div>
          <table className="ResultInfoTable">
            <tbody>
              {LPMReport[idx].map((i, j) => {
                return (
                  <tr key={`LPMReport_` + j} className="ResultInfoRow">
                    <td className="ResultInfoRowHead">{i.alias}</td>
                    <td className="ResultInfoRowValue">
                      {i.value.replace("<br/>", " / ")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="SubPanelTitle">LPM/LPMit Study</div>
          <table className="ResultInfoTable">
            <tbody>
              {LPMStudy[idx].map((i, j) => {
                return (
                  <tr key={`LPMStudy_` + j} className="ResultInfoRow">
                    <td className="ResultInfoRowHead">{i.alias}</td>
                    <td className="ResultInfoRowValue">
                      {i.value.replace("<br/>", " / ")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="SubPanelTitle">LPM/LPMit Works</div>
          <table className="ResultInfoTable">
            <tbody>
              {LPMWorks[idx].map((i, j) => {
                return (
                  <tr key={`LPMWorks_` + j} className="ResultInfoRow">
                    <td className="ResultInfoRowHead">{i.alias}</td>
                    <td className="ResultInfoRowValue">
                      {isNaN(i.value)
                        ? i.value.replace("<br/>", " / ")
                        : i.value}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )
    );
    return <>{layout}</>;
  }
}

export default eLPMIS;
